module.exports = __webpack_public_path__ + "static/media/under25s_steering.3e2411c6.svg";